import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@gemini/core';
export const SecondaryContainer = ({ gridColumn, children }) => (_jsx(Box, { as: "div", display: {
        'breakpoint.base': 'none',
        'breakpoint.xl': 'flex',
    }, flexDirection: "column", height: "auto", rowGap: "spacing.32", gridColumn: gridColumn, children: children }));
